import type { FC } from "react";
import type { InspectionPhoto } from "../../api/dto/InspectionPhoto";
import {
  buildPhotoLayout,
  InspectionPhotoLayoutLineL,
  InspectionPhotoLayoutLineLL,
  InspectionPhotoLayoutLineLP,
  InspectionPhotoLayoutLineP,
  InspectionPhotoLayoutLinePL,
  InspectionPhotoLayoutLinePP,
  InspectionPhotoLayoutLinePPP,
} from "./inspectionLayoutBuilder";
import { useAssetUrl } from "./useAssetUrl";

export const InspectionPhotoLayoutIndicator: FC<{ photos: InspectionPhoto[] }> = (props) => {
  const layout = buildPhotoLayout(props.photos);

  return (
    <div>
      {layout.map((line, i) => {
        const baseWidth = 18; // 18rem, ofwel w-72
        const gap = 0.5; // 0.5rem, ofwel gap-2
        return (
          <div key={i} className={"flex items-start justify-between w-72 mt-2"}>
            {/* Width of image is 1/n - 12px/n */}
            {line instanceof InspectionPhotoLayoutLinePPP && (
              <div className={"flex items-start justify-between w-full"}>
                <PreviewImage
                  photo={line.photoA}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
                <PreviewImage
                  photo={line.photoB}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
                <PreviewImage
                  photo={line.photoC}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
              </div>
            )}
            {line instanceof InspectionPhotoLayoutLinePL && (
              <>
                <PreviewImage
                  photo={line.photoA}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
                <PreviewImage
                  photo={line.photoB}
                  width={baseWidth - (baseWidth - 2 * gap) / 3 - gap}
                  height={(baseWidth - (baseWidth - 2 * gap) / 3 - gap) / 1.75}
                />
              </>
            )}
            {line instanceof InspectionPhotoLayoutLineLP && (
              <>
                <PreviewImage
                  photo={line.photoA}
                  width={baseWidth - (baseWidth - 2 * gap) / 3 - gap}
                  height={(baseWidth - (baseWidth - 2 * gap) / 3 - gap) / 1.75}
                />
                <PreviewImage
                  photo={line.photoB}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
              </>
            )}
            {line instanceof InspectionPhotoLayoutLinePP && (
              <>
                <PreviewImage
                  photo={line.photoA}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
                <PreviewImage
                  photo={line.photoB}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
                <div style={{ width: `${(baseWidth - 2 * gap) / 3}rem` }}></div>
              </>
            )}
            {line instanceof InspectionPhotoLayoutLineLL && (
              <>
                <PreviewImage
                  photo={line.photoA}
                  width={(baseWidth - 2 * gap) / 2}
                  height={(baseWidth - 2 * gap) / 2 / 1.75}
                />
                <PreviewImage
                  photo={line.photoB}
                  width={(baseWidth - 2 * gap) / 2}
                  height={(baseWidth - 2 * gap) / 2 / 1.75}
                />
              </>
            )}
            {line instanceof InspectionPhotoLayoutLineP && (
              <>
                <PreviewImage
                  photo={line.photoA}
                  width={(baseWidth - 2 * gap) / 3}
                  height={((baseWidth - 2 * gap) / 3) * 1.75}
                />
                <div style={{ width: `${(baseWidth - 2 * gap) / 3}rem` }}></div>
                <div style={{ width: `${(baseWidth - 2 * gap) / 3}rem` }}></div>
              </>
            )}
            {line instanceof InspectionPhotoLayoutLineL && (
              <>
                <PreviewImage
                  photo={line.photoA}
                  width={(baseWidth - 2 * gap) / 2}
                  height={(baseWidth - 2 * gap) / 2 / 1.75}
                />
                <div style={{ width: `${(baseWidth - 2 * gap) / 2}rem` }}></div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

interface PreviewImageProps {
  photo: InspectionPhoto;
  width: number;
  height: number;
}
const PreviewImage: FC<PreviewImageProps> = (props) => {
  const { getInspectionPhotoUrl } = useAssetUrl();

  return (
    <div
      style={{ height: `${props.height}rem`, width: `${props.width}rem` }}
      className={"relative overflow-hidden border border-slate-200 rounded-lg"}
    >
      {props.photo.rotation === 90 || props.photo.rotation === 270 ? (
        <>
          <div
            style={{
              height: `${props.width}rem`,
              width: `${props.height}rem`,
              transform: `translate(-50%, -50%) rotate(${props.photo.rotation}deg)`,
              backgroundImage: `url(${getInspectionPhotoUrl(props.photo)})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
            className={"absolute top-1/2 left-1/2"}
          ></div>
        </>
      ) : (
        <>
          <div
            style={{
              height: `${props.height}rem`,
              width: `${props.width}rem`,
              transform: `translate(-50%, -50%) rotate(${props.photo.rotation}deg)`,
              backgroundImage: `url(${getInspectionPhotoUrl(props.photo)})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
            className={"absolute top-1/2 left-1/2"}
          ></div>
        </>
      )}
    </div>
  );
};
